import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@nutastic/nutastic-react-app';

const ResourcesModal = ({ onClose, show }) => {
    const componentClass = 'resourcesModal';

    return <Modal
        show={show}
        className={`${componentClass}__container animated fadeIn`}
        title="Hotel Information"
        onClose={onClose}
        closeBtn={<i className="fa fa-times-circle-o" />}
    >
        <div className={componentClass}>
            <div className={`${componentClass}__body`}>
                <p className="mb-5">
                    <b>Hotel Indigo - Atlanta Airport</b><br />
                    <i>1776 Harvard Ave, College Park, GA 39337</i><br />
                    <i>404-767-8881</i><br />
                    <small><b>Notes:</b> Located in College Park. Free airport shuttle and adjacent to a Marta station. Call and mention the wedding for room discount</small>

                    <br /><br />

                    <b>EVEN Hotel Atlanta - Cobb Galleria</b><br />
                    <i>3380 Overton Park Dr SE, Atlanta, GA 30339</i><br />
                    <i>770-800-0393</i><br />
                    <a href="https://www.evenhotels.com/redirect?path=hd&brandCode=VN&localeCode=en&regionCode=1&hotelCode=ATLOP&_PMID=99801505&GPC=PBW&cn=no&viewfullsite=true" target="_blank">
                        Click here to book room block
                    </a>

                    <br /><br />

                    <b>La Quinta Inn & Suites by Wyndham</b><br />
                    <i>2415 Paces Ferry Rd SE, Atlanta, GA 30339</i><br />
                    <i>770-801-9002</i><br />
                    <small>Notes: close proximity to the venue but no room block rates. This location is also near Atlanta Ballpark / Galleria.</small>
                </p>
            </div>
        </div>
    </Modal>;
};

ResourcesModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool
};
export default ResourcesModal;
